import * as Yup from "yup";

const insumoValidator = Yup.object().shape({
  descricao: Yup.string().required("Descrição"),
  quantidade: Yup.number()
    .required("Quantidade")
    .min(0.001, "Quantidade deve ser maior que 0"),
  valorUnitario: Yup.number()
    .required("Valor Unitário")
    .min(0.01, "Valor Unitário deve ser maior ou igual a 0.01"),
  valorTotal: Yup.number()
    .required("Valor Total")
    .min(0.01, "Valor Total deve ser maior ou igual a 0.01"),
});

const insumoListValidator = Yup.array().of(insumoValidator);

export { insumoValidator, insumoListValidator };
